import { useParams } from 'react-router-dom';
import { useGetProjectByIdQuery } from 'src/services';
import { useAppSelector } from 'src/store';
import moment from 'moment-timezone';
import { ISO_DATE_FORMAT } from 'src/shared/constants';
import { transformDateHelper } from 'src/helpers/transformDateHelper';
import { DateFormat } from 'src/constants/dateTimeFormatOption';

export const PdfReportHeader = () => {
  const { start_time = '', end_time = '', timezone } = useAppSelector((s) => s.analyticSlices);

  const { id } = useParams();

  const { data: currentProject } = useGetProjectByIdQuery({ id: id });

  const startTzTimeUtc = start_time && moment.utc(start_time, ISO_DATE_FORMAT);
  const endTzTimeUtc = end_time && moment.utc(end_time, ISO_DATE_FORMAT);

  const startTzTime = startTzTimeUtc?.clone().tz(timezone.value);
  const endTzTime = endTzTimeUtc?.clone().tz(timezone.value);

  const diffHours = endTzTime?.diff(startTzTime, 'hours') ?? 0;

  const isSameDayByHours = diffHours < 24;

  return (
    <div className="flex-row row size-full md:gap-[10px] gap-[6px]  justify-between items-center pdf-header hidden max-h-[41.1px] min-h-[41.1px]">
      <div className="flex items-center gap-2.5">
        <p className="font-bold text-xl">CoSupport AI — {currentProject?.name}</p>
      </div>
      <div className="flex items-center gap-2.5">
        <p className="font-bold text-sm">Report for </p>
        <div className="flex items-center gap-1">
          <p className="font-medium text-sm opacity-50">
            {isSameDayByHours
              ? transformDateHelper(startTzTime?.format(ISO_DATE_FORMAT), DateFormat.MONTH_DAY_YEAR)
              : `${transformDateHelper(
                  startTzTime.format(ISO_DATE_FORMAT),
                  DateFormat.MONTH_DAY_YEAR,
                )} - ${transformDateHelper(
                  endTzTime.format(ISO_DATE_FORMAT),
                  DateFormat.MONTH_DAY_YEAR,
                )}`}
          </p>
        </div>
      </div>
    </div>
  );
};
